export class NgorongoroText {
  paragraphHeaders = [
    'Geology & Formation',
    'Life & History',
    'Crater Beauty',
    'Ngorongoro Conservation Area Map'
  ];

  paragraphs = [
    `<p class="generated-p">
          It is early morning -- thick fog envelops your Land Cruiser as you journey into rain forest
          territory. Just as you begin to wonder where you are, the driver takes a turn and heads down a
          descent.
          The fog begins to lift and you know you’re about to be a part of something magical. Welcome to the Ngorongoro Conservation Area.</p>`,
    `<p class="generated-p">
                       Millions of years ago, an ancient volcano about as tall as Mount Kilimanjaro experienced a massive eruption.
                        The eruption was so large it led to the volcano collapsing onto itself, resulting in the splendid caldera now known
                        as Ngorongoro Crater. As the centuries passed, the crater filled with lush vegetation, an abundance of wildlife,
                        and became home to the nomadic Maasai people.
                    </p>`,
    `<p class="generated-p">
                        Ngorongoro Crater has so much life and history to it. Plan to spend 1 day here at a minimum, to experience all the park has to offer.
                        The 3,202 sq. mi area surrounding the beautiful crater rim is home to 25,000 mammals. Here in Ngorongoro Crater,
                        you have one of the best chances in the world to get a look at the incredibly rare Black Rhino. You can find not only rhinos,
                        but the complete set of the Big 5: <ul>
                                        <li>African Elephant</li>
                                        <li>Lion</li>
                                        <li>African Leopard</li>
                                        <li>Rhino</li>
                                        <li>African Buffalo</li>
                                        </ul>
                    </p>`,
    `<p class="generated-p">
        On the crater’s ground floor, you’ll get a chance to visit the salt flat along Lake Magadi, and Lake Ndutu --
        both are home to huge gatherings of wildlife. Most special though, here in Ngorongoro Conservation Area you will be
        cruising along land where earliest men have roamed. <a class="generated-a" href="../../national-parks/olduvai-gorge">Olduvai Gorge</a> holds the world’s oldest known record of mankind’s evolution.
        Ngorongoro is an opportunity to witness many of God’s blessings firsthand- an epicenter of life that has been flourishing for millenia.
    </p>`,
    `<p class="generated-p">
        Ngorongoro Conservation Area is a massive area of land in the Great Rift Valley of East Africa. The main, southern entrance to the park is located about 10 miles north of Karatu, and about 30 miles from
        <a class="generated-a" href="../../national-parks/lake-manyara">Lake Manyara National Park</a>. Driving through Ngorongoro Conservation Area is a destination in itself. Just past the entrance to the park,
        you will drive through a foggy rainforest on the crater rim itself, before the fog gives way to massive dryland plains housing Maasai people, and plenty of animals such as Zebra, various cattle, and Giraffes.
        This road will lead you to other areas to explore, such as <a class="generated-a" href="../../national-parks/serengeti">Serengeti National Park</a> and <a class="generated-a" href="../../national-parks/olduvai-gorge">Olduvai Gorge</a>.
    </p>`

  ];

  factsHeader = 'Ngorongoro Facts';
  facts = [
    '42,000 maasai people live in the Ngorongoro Conservation Area.',
    `The park was established in 1959, and became a UNESCO world heritage site in 1979.`,
    `As of 2009, only wildlife is allowed to live in the Ngorongoro Crater. Maasai populations used to live among the animals, but are now required to reside in non-crater stretches of the Ngorongoro Conservation Area.`,
    `Critically endangered - roughly 5,000 Black Rhinos still exist in the world, with Ngorongoro Crater being one of the last places in the world to spot one.`
  ];
  badge = `<i><span class="badge badge-secondary px-2 py-1">Densely Populated!</span></i>`;
}
